import { StateTitles } from "../../pages/InspectionList/StateHelpers";
import Toggle from "../Inputs/Toggle";
import { StateToIcon } from "./MapMarker";
import styled from "styled-components";
import MapLayerControl from "./MapLayerControl/MapLayerControl";
import { Portal } from "./MapPortal";
import { Maps } from "./MapTileLayer";
import { InspectionfieldStateEnum } from "./__generated__/MapListViewFragment.graphql";

interface MapControlsProps {
  activeStateMapMarkers: InspectionfieldStateEnum[];
  onChangeActiveStateMapMarkers: (
    state: InspectionfieldStateEnum,
    active: boolean
  ) => void;
  activeLayer: Maps;
  onChangeActiveLayer: (layer: Maps) => void;
}

const MapControls = ({
  activeStateMapMarkers,
  onChangeActiveStateMapMarkers,
  activeLayer,
  onChangeActiveLayer,
}: MapControlsProps) => {
  const mapControlConfigs: InspectionfieldStateEnum[] = [
    "ASSIGNED",
    "PLANNED",
    "IN_PROGRESS",
  ];
  return (
    <Portal>
      <MapControlsContainer>
        {mapControlConfigs.map((config) => (
          <MapMarkerToggle
            key={`toggle_${config}`}
            state={config}
            active={activeStateMapMarkers.includes(config)}
            onChange={onChangeActiveStateMapMarkers}
          />
        ))}
        <MapLayerControl
          activeLayer={activeLayer}
          onChangeActiveLayer={onChangeActiveLayer}
        />
      </MapControlsContainer>
    </Portal>
  );
};

interface MapMarkerToggleProps {
  state: InspectionfieldStateEnum;
  active: boolean;
  onChange: (state: InspectionfieldStateEnum, value: boolean) => void;
}

const MapMarkerToggle = ({ state, active, onChange }: MapMarkerToggleProps) => {
  const mapMarkerIcon = StateToIcon[state];

  return (
    <MapMarkerToggleContainer>
      <MapMarkerLabel>
        <MapMarkerIcon
          src={`${mapMarkerIcon}#svgView(viewBox(10, 5, 40, 40))`}
        />
        <span>{StateTitles[state]}</span>
      </MapMarkerLabel>
      <Toggle value={active} setValue={(value) => onChange(state, value)} />
    </MapMarkerToggleContainer>
  );
};

const MapControlsContainer = styled.div`
  position: absolute;
  margin: 15px;
`;

const MapMarkerToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  width: 202px;
  margin: 8px 0;
  padding: 8px;
  background: rgba(33, 37, 41, 0.8);
  border-radius: 5px;
`;

const MapMarkerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  color: white;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

const MapMarkerIcon = styled.img`
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
`;

export default MapControls;
